import PlayerOfTheGameWinnersModel from '../models/PlayerOfTheGameWinnersModel';
import { mlbBaseDefaults } from './defaults';

export default {
    ...mlbBaseDefaults,
    pathTemplate: 'apps/player-of-the-game/game/json/winners/{gamePk}.json',
    model: PlayerOfTheGameWinnersModel,
    expires: 300
};
